var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashbordIcon02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 62 62",
    style: {
      enableBackground: "new 0 0 62 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E85956;}\r\n\t.st1{fill:#F2FBFF;}\r\n\t.st2{fill:#62DBFB;}\r\n\t.st3{fill:#DFF6FD;}\r\n\t.st4{fill:#FD8087;}\r\n\t.st5{fill:#99E6FC;}\r\n\t.st6{fill:#01D0FB;}\r\n\t.st7{fill:#52DBA3;}\r\n\t.st8{fill:#5680A6;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 31,
    cy: 31,
    r: 30.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.2,22v1.4L40,23.5v0.7l0.2,0.1v12.6l-4.9,5.4H18.5c-0.2,0-0.4-0.2-0.4-0.4v-1l0.3-0.1v-0.7L18.1,40V24.3 l0.3-0.1v-0.6l-0.3-0.1V22l1.2-0.6H39L40.2,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.5,18.3h-4.2l-0.1-0.1h-0.8l-0.1,0.1H23.2l-0.1-0.1h-0.8l-0.1,0.1h-2.4c-1,0-1.8,0.8-1.8,1.8V22h22.2v-1.9 C40.2,19.1,39.4,18.3,38.5,18.3L38.5,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M40.2,35.6v1.2l-4.9,5.4h-1.8c0-0.3-0.1-0.6-0.1-0.9c0-3.2,2.6-5.8,5.8-5.8C39.6,35.6,39.9,35.6,40.2,35.6 L40.2,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.3,22v20.3h-0.8c-0.2,0-0.4-0.2-0.4-0.4V22H19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.3,27.5h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C22.7,27.4,22.5,27.5,22.3,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26,27.5h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C26.4,27.4,26.2,27.5,26,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.7,27.5h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C30.1,27.4,29.9,27.5,29.7,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.4,27.5h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C33.8,27.4,33.6,27.5,33.4,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.3,31.2h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C22.7,31,22.5,31.2,22.3,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.7,31.2h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C30.1,31,29.9,31.2,29.7,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.4,31.2h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C33.8,31,33.6,31.2,33.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.3,34.9h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C22.7,34.7,22.5,34.9,22.3,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26,34.9h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C26.4,34.7,26.2,34.9,26,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.7,34.9h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C30.1,34.7,29.9,34.9,29.7,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M22.3,38.6h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C22.7,38.4,22.5,38.6,22.3,38.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26,38.6h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C26.4,38.4,26.2,38.6,26,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.7,38.6h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C30.1,38.4,29.9,38.6,29.7,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.4,34.9h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C33.8,34.7,33.6,34.9,33.4,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37,27.5h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C37.4,27.4,37.3,27.5,37,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M37,34.8h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C37.4,34.7,37.3,34.8,37,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26,31.2h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v1 C26.4,31,26.2,31.2,26,31.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21,18.3c-1,0-1.8,0.8-1.8,1.8V22h-1.2v-1.9c0-1,0.8-1.8,1.8-1.8H21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M36.3,31.5C36.3,31.5,36.3,31.5,36.3,31.5c-0.1,0-0.3-0.1-0.3-0.2l-0.8-0.9c-0.2-0.2-0.1-0.5,0.1-0.6 s0.5-0.1,0.6,0.1l0.5,0.5l1.3-1.2c0.2-0.2,0.5-0.2,0.6,0c0.2,0.2,0.2,0.5,0,0.6l-1.6,1.5C36.6,31.5,36.5,31.5,36.3,31.5L36.3,31.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M25,17.4l0,1.9c0,0.7-0.6,1.4-1.4,1.4h-0.9c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h0.9 c0.3,0,0.5-0.2,0.5-0.5l0-1.9c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1c0,0,0,0,0,0c-0.3,0-0.5,0.2-0.5,0.5v0.9l-0.9,0v-0.9 c0-0.7,0.6-1.4,1.4-1.4h0c0.4,0,0.7,0.1,1,0.4C24.8,16.7,25,17,25,17.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.1,17.4l0,1.9c0,0.7-0.6,1.4-1.4,1.4h-0.9c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h0.9 c0.3,0,0.5-0.2,0.5-0.5l0-1.9c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1h0c-0.3,0-0.5,0.2-0.5,0.5v0.9h-0.9v-0.9 c0-0.7,0.6-1.4,1.4-1.4h0c0.4,0,0.7,0.1,1,0.4C35.9,16.7,36.1,17,36.1,17.4L36.1,17.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M40.2,23.4v0.9c0,0,0,0,0,0H18.1v-0.9L40.2,23.4C40.2,23.4,40.2,23.4,40.2,23.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.2,40.5c0,0.2-0.2,0.4-0.4,0.4H18.1V40h16.7C35,40,35.2,40.2,35.2,40.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 39.3,
    cy: 41.4,
    r: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.7,40.5h-1c-0.2,0-0.4-0.2-0.4-0.4v-1c0-0.2-0.2-0.4-0.4-0.4h-1c-0.2,0-0.4,0.2-0.4,0.4v1 c0,0.2-0.2,0.4-0.4,0.4h-1c-0.2,0-0.4,0.2-0.4,0.4v1c0,0.2,0.2,0.4,0.4,0.4h1c0.2,0,0.4,0.2,0.4,0.4v1c0,0.2,0.2,0.4,0.4,0.4h1 c0.2,0,0.4-0.2,0.4-0.4v-1c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4-0.2,0.4-0.4v-1C42.1,40.6,41.9,40.5,41.7,40.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIcon02);
export default __webpack_public_path__ + "static/media/dashbord-icon-02.8f869fb32de00fa9f8d983b95f478584.svg";
export { ForwardRef as ReactComponent };